if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openedId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${openedId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        // Resilience: if the opener's id somehow isn't in the modal, fall back
        // to the first media rather than throwing (which left the modal blank
        // with only the close button).
        const activeMedia =
          this.querySelector(`[data-media-id="${openedId}"]`) || this.querySelector('[data-media-id]');
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
